import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Home"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.4575 1.65752C12.1849 1.44212 11.8001 1.44212 11.5275 1.65752L0.75 10.065L1.68 11.25L3 10.215V19.5C3 20.3284 3.67157 21 4.5 21H19.5C20.3284 21 21 20.3284 21 19.5V10.2225L22.32 11.25L23.25 10.0725L12.4575 1.65752ZM13.5 19.5H10.5V13.5H13.5V19.5ZM15 19.5V13.5C15 12.6716 14.3284 12 13.5 12H10.5C9.67157 12 9 12.6716 9 13.5V19.5H4.5V9.04502L12 3.20252L19.5 9.05252V19.5H15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Home.vue"]]);
